/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      managerId: "",
      supplierName: "",
      type: "",
      typeOfDocuments: "",
      identity: "",
      gpkd: "",
      taxId: "",
      totalValueSuccess: "",
      deductions: "",
      successfulOrders: "",
      failedOrders: "",
      dateFrom: "",
      dateTo: "",
      status: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        managerId: "",
        supplierName: "",
        type: "",
        typeOfDocuments: "",
        identity: "",
        gpkd: "",
        taxId: "",
        totalValueSuccess: "",
        deductions: "",
        successfulOrders: "",
        failedOrders: "",
        dateFrom: "",
        dateTo: "",
        status: "",
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", maxWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã quản lý trên sàn giao dịch TMĐT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tên nhà cung cấp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại hình
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại giấy tờ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số CMND/CCCD/Hộ chiếu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số GPKD
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                MST
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Tổng giá trị hàng hóa của các đơn hàng đã giao dịch thành công
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tổng số lượng các đơn hàng đã giao dịch thành công
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tổng số lượng các đơn hàng đã giao dịch không thành công
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Thời gian hoạt động trên Sàn của quý
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Trạng thái
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", whiteSpace: "wrap" }}>
                Tổng giá trị hàng hóa của các đơn hàng đã giao dịch thành công (chưa trừ các khoản
                khuyến mại, giảm giá, chiết khấu, hỗ trợ khác)
              </Td>
              <Td style={{ textAlign: "center" }}>Các khoản giảm trừ</Td>
              <Td style={{ textAlign: "center" }}>Từ ngày</Td>
              <Td style={{ textAlign: "center" }}>Đến ngày</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>[6]</Td>
              <Td style={{ textAlign: "center" }}>[7]</Td>
              <Td style={{ textAlign: "center" }}>[8]</Td>
              <Td style={{ textAlign: "center" }}>[9]</Td>
              <Td style={{ textAlign: "center" }}>[10]</Td>
              <Td style={{ textAlign: "center" }}>[11]</Td>
              <Td style={{ textAlign: "center" }}>[12]</Td>
              <Td style={{ textAlign: "center" }}>[13]</Td>
              <Td style={{ textAlign: "center" }}>[14]</Td>
              <Td style={{ textAlign: "center" }}>[15]</Td>
              <Td style={{ textAlign: "center" }}>[16]</Td>
              <Td style={{ textAlign: "center" }}>[17]</Td>
              <Td style={{ textAlign: "center" }}>[18]</Td>
              <Td style={{ textAlign: "center" }}>[19]</Td>
              <Td style={{ textAlign: "center" }}>[20]</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="managerId"
                    value={item.managerId}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="supplierName"
                    value={item.supplierName}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "type", e.target.value)}
                  >
                    <option value="value1">Tổ chức VN</option>
                    <option value="value2">Cá nhân/hộ kinh doanh VN</option>
                    <option value="value3">Tổ chức nước ngoài</option>
                    <option value="value4">Cá nhân/hộ kinh doanh nước ngoài (không cư trú)</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "typeOfDocuments", e.target.value)}
                  >
                    <option value="value1">Thẻ CCCD</option>
                    <option value="value2">CMND</option>
                    <option value="value3">Hộ chiếu</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="identity"
                    value={item.identity}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable id={item.id} name="gpkd" value={item.gpkd} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="totalValueSuccess"
                    value={item.totalValueSuccess}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="deductions"
                    value={item.deductions}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="successfulOrders"
                    value={item.successfulOrders}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="failedOrders"
                    value={item.failedOrders}
                    onChange={handleChange}
                  />
                </Td>
                {/* <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="number"
                    value={item.number}
                    onChange={handleChange}
                  />
                </Td> */}
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="dateFrom"
                    value={item.dateFrom}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="dateTo"
                    value={item.dateTo}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "status", e.target.value)}
                  >
                    <option value="value1">Thêm mới</option>
                    <option value="value2">Thay thế</option>
                  </select>
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
      <Footer formData={formData} />
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
